
import React from "react";
import "../ConfigurePayout.css";
import TextField from "@mui/material/TextField";

const CohortCreateComponent = (props) => {
  return (
    <div className="fs-form-row">
      <div className="fs-form-column">
        <TextField
          className="fs-input-field"
          label="Name"
          name="name"
          value={props.formData.name}
          onChange={props.handleChangeCohort}
        />
        <TextField
          className="fs-input-field"
          label="Area Name"
          name="areaName"
          value={props.formData.areaName}
          onChange={props.handleChangeCohort}
        />
        <TextField
          className="fs-input-field"
          label="Description"
          name="description"
          value={props.formData.description}
          onChange={(e) => {
            const upperCaseValue = e.target.value.toUpperCase();
            props.handleChangeCohort({
              target: {
                name: e.target.name,
                value: upperCaseValue,
              },
            });
          }}
        />
        <TextField
          className="fs-input-field"
          label="Latitude"
          name="latitude"
          value={props.formData.latitude}
          onChange={props.handleChangeCohort}
        />
      </div>
      
      <div className="fs-form-column">
        <TextField
          className="fs-input-field"
          label="Longitude"
          name="longitude"
          value={props.formData.longitude}
          onChange={props.handleChangeCohort}
        />
        <TextField
          className="fs-input-field"
          label="Cohort Type ID"
          name="cohortTypeId"
          value={props.formData.cohortTypeId}
          onChange={props.handleChangeCohort}
        />
        <TextField
          className="fs-input-field"
          label="VM ID's"
          name="vmIDs"
          value={props.formData.vmIDs}
          onChange={props.handleChangeCohort}
        />
        <TextField
          className="fs-input-field"
          label="User ID"
          name="userID"
          value={props.formData.userID}
          onChange={props.handleChangeCohort}
        />
      </div>
    </div>
  );
};

export default CohortCreateComponent;